module.exports = __webpack_public_path__ + "static/media/04.2ff53f9c.png";